module.exports = __webpack_public_path__ + "img/mindbody.bb12b32b.png";